
import { defineComponent, computed, PropType } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { axiosSetting } from '@/utils/axiosSetting'
import Button from '@/components/elements/Button.vue'
import { useSearchCondition } from '@/utils/useSearchCondition'

export default defineComponent({
  components: {
    Button
  },

  props: {
    type: {
      type: String as PropType<'hospital' | 'latter'>,
      default: 'hospital'
    },
    seachData: {
      type: Object,
      required: true
    },
    canDelete: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      require: false
    }
  },

  setup(props, { emit }) {
    const router = useRouter()
    const store = useStore()

    const {
      getSearchConditionFromQuery,
      getSearchConditionTag
    } = useSearchCondition()

    const currentConditions = computed(() =>
      getSearchConditionFromQuery(props.seachData.search_history, props.type)
    )

    const currentConditionsTag = computed(() =>
      getSearchConditionTag(currentConditions.value)
    )

    const searchUrl = computed(() => {
      let path = `/search/${props.type}/list`

      const conditions = props.seachData.search_history
      Object.keys(conditions).forEach((key) => {
        if (key === 'prefectures') path += `/pr_${conditions[key].join('+')}`

        if (key === 'program_subjects')
          path += `/sj_${conditions[key].join('+')}`

        if (key === 'hospital_class') path += `/cl_${conditions[key].join('+')}`

        if (key === 'feature_tag') path += `/pk_${conditions[key].join('+')}`

        if (key === 'designated_hospital')
          path += `/dh_${conditions[key].join('+')}`

        if (key === 'discerning_conditions')
          path += `/kw_${conditions[key].join('+')}`

        if (key === 'bonus') path += `/rb_1`

        if (key === 'overtime_hours_mavg') path += `/ro_1`

        if (key === 'house') path += `/rh_1`

        if (key === 'j_graduating_school') path += `/gs_1`

        if (key === 'bed_num_lo') {
          const reg = /bn_-(\d*)/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'bn_' + conditions[key] + '-$1')
          } else {
            path += `/bn_${conditions[key]}-`
          }
        }

        if (key === 'bed_num_hi') {
          const reg = /bn_(\d*)-/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'bn_$1-' + conditions[key])
          } else {
            path += `/bn_-${conditions[key]}`
          }
        }

        if (key === 'department_bed_num_lo') {
          const reg = /sb_-(\d*)/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'sb_' + conditions[key] + '-$1')
          } else {
            path += `/sb_${conditions[key]}-`
          }
        }

        if (key === 'department_bed_num_hi') {
          const reg = /sb_(\d*)-/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'sb_$1-' + conditions[key])
          } else {
            path += `/sb_-${conditions[key]}`
          }
        }

        if (key === 'resident_num_lo') {
          const reg = /mi_-(\d*)/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'mi_' + conditions[key] + '-$1')
          } else {
            path += `/mi_${conditions[key]}-`
          }
        }

        if (key === 'resident_num_hi') {
          const reg = /mi_(\d*)-/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'mi_$1-' + conditions[key])
          } else {
            path += `/mi_-${conditions[key]}`
          }
        }

        if (key === 'instructor_num_lo') {
          const reg = /si_-(\d*)/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'si_' + conditions[key] + '-$1')
          } else {
            path += `/si_${conditions[key]}-`
          }
        }

        if (key === 'instructor_num_hi') {
          const reg = /si_(\d*)-/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'si_$1-' + conditions[key])
          } else {
            path += `/si_-${conditions[key]}`
          }
        }

        if (key === 'doctor_num_lo') {
          const reg = /dn_-(\d*)/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'dn_' + conditions[key] + '-$1')
          } else {
            path += `/dn_${conditions[key]}-`
          }
        }

        if (key === 'doctor_num_hi') {
          const reg = /dn_(\d*)-/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'dn_$1-' + conditions[key])
          } else {
            path += `/dn_-${conditions[key]}`
          }
        }

        if (key === 'positions_num_lo' || key === 'recruitment_num_lo') {
          const reg = /pn_-(\d*)/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'pn_' + conditions[key] + '-$1')
          } else {
            path += `/pn_${conditions[key]}-`
          }
        }

        if (key === 'positions_num_hi' || key === 'recruitment_num_hi') {
          const reg = /pn_(\d*)-/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'pn_$1-' + conditions[key])
          } else {
            path += `/pn_-${conditions[key]}`
          }
        }

        if (key === 'income_lo' || key === 's_salary3_num_lo') {
          const reg = /ai_-(\d*)/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'ai_' + conditions[key] + '-$1')
          } else {
            path += `/ai_${conditions[key]}-`
          }
        }

        if (key === 'income_hi' || key === 's_salary3_num_hi') {
          const reg = /ai_(\d*)-/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'ai_$1-' + conditions[key])
          } else {
            path += `/ai_-${conditions[key]}`
          }
        }

        if (key === 'shifts_num_lo' || key === 's_shifts3_num_lo') {
          const reg = /sn_-(\d*)/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'sn_' + conditions[key] + '-$1')
          } else {
            path += `/sn_${conditions[key]}-`
          }
        }

        if (key === 'shifts_num_hi' || key === 's_shifts3_num_hi') {
          const reg = /sn_(\d*)-/
          if (path.search(reg) > -1) {
            path = path.replace(reg, 'sn_$1-' + conditions[key])
          } else {
            path += `/sn_-${conditions[key]}`
          }
        }

        if (key === 'free_word') path += `/fw_${conditions[key]}`
      })

      return path
    })

    // この条件で検索する
    const searchThisCondition = (e: any) => {
      if (e.ctrlKey || e.metaKey) return true
      e.preventDefault()

      if (store.state.visibleSearchModal) store.dispatch('closeSearchModal')

      router.push(searchUrl.value)
    }

    // 削除する
    const deleteThisCondition = (id: number, ev: any) => {
      ev.preventDefault()
      ev.stopPropagation()

      const deleteCondition = axiosSetting('app', 'action')

      deleteCondition
        .post('/api/v1/search_history_dell', { search_history_id: id })
        .then((res) => {
          emit('delete-condition', {
            index: props.index,
            type: props.type
          })
        })
    }

    return {
      currentConditions,
      currentConditionsTag,
      searchUrl,
      searchThisCondition,
      deleteThisCondition
    }
  }
})
